// Meta Pixel utilities
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = (pixelId: string) => {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const load = () => {
    ;(function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e)
      t.async = true
      t.src = v
      const target = b.head || b.getElementsByTagName('head')[0] || b.body
      if (target) {
        target.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
  }

  if ('requestIdleCallback' in window) {
    ;(window as any).requestIdleCallback(load)
  } else {
    setTimeout(load, 200)
  }
}

export const trackAddToCart = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}

export const trackEvent = (eventName: string, parameters?: any) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, parameters)
  }
}
